import { Outlet } from "react-router-dom";
import Layout from "@commons/Layout";
import { PageProvider } from "@providers/PageProvider";
import LoadingPage from "@commons/Loading/LoadingPage";

function App() {
  return (
    <>
      <PageProvider>
        <LoadingPage />
        <Layout>
          <Outlet />
        </Layout>
      </PageProvider>
    </>
  );
}

export default App;
